import { InviteCode } from "@common/types/inviteCode";
import {
    validateManageClientAssignment,
    validateManageTeamRole,
} from "@common/helpers/permissions/organizationRequestValidators";
import { useWorkspacesList } from "@api/workspace.api";
import { OrganizationAction } from "@common/userOrganizationRoles";
import { useActiveOrganizationRole } from "./useActiveOrganizationRole";
import { useCanPerformOrganizationAction } from "./useCanPerformOrganizationAction";

export function useCanCancelOrganizationInvite(invite: InviteCode) {
    const role = useActiveOrganizationRole();
    const workspacesQuery = useWorkspacesList();
    const canCancelByRole = useCanPerformOrganizationAction(
        OrganizationAction.CANCEL_INVITE,
    );

    if (!canCancelByRole || !workspacesQuery?.data) {
        return false;
    }

    if (!invite.organizationRole || !invite.workspaceAssignments) {
        return false;
    }

    const actingUserWorkspaceAssignments = workspacesQuery.data.map(
        (w) => w.id,
    );
    const inviteWorkspaceAssignments = invite.workspaceAssignments.map(
        (assignment) => assignment.workspace.id,
    );

    return (
        !validateManageTeamRole(role!, invite.organizationRole) &&
        !validateManageClientAssignment(
            actingUserWorkspaceAssignments,
            inviteWorkspaceAssignments,
        )
    );
}
